"use client";

import { useEffect, useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Plus, Minus, ShoppingCart, Menu, X, Trash2, Tag } from "lucide-react";
import "./Css/Posdashboard.css";
import {
  server_post_data,
  get_pos_qr_menu,
  process_order,
  APL_LINK,
} from "../ServiceConnection/serviceconnection.js";
import {
  RetrieveDataintoIndexDB,
  RetrieveDataintoIndexDBOrder,
  StoreDataCustomerOrderDetailsintoIndexDB,
  StoreDataCustomerOrderintoIndexDB,
  StoreDataintoIndexDB,
  StoreDataItemintoIndexDB,
  UpdateDataItemDetailsintoIndexDB,
} from "../LocalConnection/OfflineConnectionNew.js";
import AddOnModal from "./Modals/AddOnModal.js";
import {
  array_data_base,
  CustomerOrder,
  CustomerOrderDetail,
  initIndexedDB,
  openIndexDB,
} from "../LocalConnection/OfflineConnection.js";
import { handleError, handleLinkClick } from "../CommonJquery/CommonJquery.js";
import { useParams } from "react-router-dom";
import { storeData } from "../LocalConnection/LocalConnection.js";
import Veg from "../Assets/veg.png";
import nonveg from "../Assets/nonveg.png";
import Logo from "../Assets/Chaileela R Logo Yellow.avif";

// ─── Razorpay SDK dynamic loader ────────────────────────────────────────────
const loadRazorpaySDK = () => {
  return new Promise((resolve) => {
    if (window.Razorpay) {
      resolve(true);
      return;
    }

    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;

    script.onload = () => {
      resolve(true);
    };

    script.onerror = () => {
      resolve(false);
    };

    document.body.appendChild(script);
  });
};

export default function Posdashboard() {
  let { id, id2 } = useParams();
  id = id || "0";
  id2 = id2 || "0";

  const [showCheckout, setShowCheckout] = useState(false);
  const [showSplash, setshowSplash] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [db, setDb] = useState(null);
  const [foodCategories, setfoodCategories] = useState([]);
  const [foodItems, setfoodItems] = useState([]);
  const [foodItemsVari, setfoodItemsVari] = useState([]);
  const [foodItemsAddon, setfoodItemsAddon] = useState([]);
  const [foodItemsAddonVari, setfoodItemsAddonVari] = useState([]);
  const [foodItemsAddonitem, setfoodItemsAddonitem] = useState([]);
  const [foodItemsAddonitemcombo, setfoodItemsAddonitemcombo] = useState([]);
  const [RestaurantName, setRestaurantName] = useState("Uprestro");
  const [RestaurantLogo, setRestaurantLogo] = useState(
    "https://backendpython.uprestro.com/assets/assets/uprestro.jpg",
  );
  const [RestaurantNameTagLine, setRestaurantTagLine] = useState(
    "Taste the Tradition",
  );
  const [RestaurantManagementData, setRestaurantManagementData] = useState([]);
  const [StoreDataDetails, setStoreDataDetails] = useState([]);
  const [totalPrice, settotalPrice] = useState(0);
  const [activetable, setactivetable] = useState(0);
  const [TaxPrice, setTaxPrice] = useState(0);
  const [TaxPer, setTaxPer] = useState(5);
  const [OrderID, setOrderID] = useState(0);
  const [ProductPrice, setProductPrice] = useState(0);
  const [StoreData, setStoreData] = useState([]);
  const [showAddonModal, setShowAddOnModal] = useState(false);
  const [TableCodeID, setTableCodeID] = useState(0);
  const [expanded, setExpanded] = useState(false);
  const [AreaID, setAreaID] = useState(0);
  const [activeState, setActiveState] = useState("dine");
  const [table_area_name, settable_area_name] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedfoodItemsVari, setselectedfoodItemsVari] = useState(null);
  const [selectedfoodItemsAddonVari, setselectedfoodItemsAddonVari] =
    useState(null);
  const [selectedfoodItemsAddon, setselectedfoodItemsAddon] = useState(null);
  const [selectedfoodItemsAddonitem, setselectedfoodItemsAddonitem] =
    useState(null);
  const [selectedfoodItemsAddonitemcombo, setselectedfoodItemsAddonitemcombo] =
    useState(null);
  const [activeCatagory, setActiveCatagory] = useState(0);
  const [notes, setNotes] = useState("");
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);

  useEffect(() => {
    console.log("StoreDataDetails", StoreDataDetails);
    console.log("StoreData", StoreData);
  }, [StoreData, StoreDataDetails]);

  useEffect(() => {
    const setDbCallback = async (result) => {
      setDb(result);
      master_data_get(result);
    };
    initIndexedDB(setDbCallback);
  }, []);

  const master_data_get = async (result) => {
    try {
      const fd = new FormData();
      fd.append("encrypted_restaurant_id", id);
      fd.append("encrypted_table_id", id2);
      const response = await server_post_data(get_pos_qr_menu, fd, "");
      const otherData = response.data.message;
      if (result == null) result = await openIndexDB();

      const transaction_call = result.transaction(array_data_base, "readwrite");
      const storeMapping = {
        CategoryManagement: otherData.category_data,
        MenuManagement: otherData.menu_data,
        VariationMenuManagement: otherData.vari_data,
        AddonManagement: otherData.addon_data,
        AddonMenuManagement: otherData.addon_vari_data,
        AddonItemManagement: otherData.addon_item_data,
        CobmoMenuManagement: otherData.combo_item_data,
        RestaurantManagement: otherData.data_restaurant,
        DiningAreaTableSetupSetting: otherData.table_data,
      };

      storeData("QR_GLOBAL_DATA", JSON.stringify(otherData.data_restaurant));

      setfoodCategories(storeMapping.CategoryManagement);
      setfoodItems(storeMapping.MenuManagement);
      setfoodItemsVari(storeMapping.VariationMenuManagement);
      setfoodItemsAddon(storeMapping.AddonManagement);
      setfoodItemsAddonVari(storeMapping.AddonMenuManagement);
      setfoodItemsAddonitem(storeMapping.AddonItemManagement);
      setfoodItemsAddonitemcombo(storeMapping.CobmoMenuManagement);
      setRestaurantManagementData(storeMapping.RestaurantManagement[0]);
      setTaxPer(storeMapping.RestaurantManagement[0].restaurant_tax);
      setRestaurantName(storeMapping.RestaurantManagement[0].restaurant_name);
      setRestaurantTagLine(
        storeMapping.RestaurantManagement[0].restaurant_tagline,
      );
      setRestaurantLogo(
        APL_LINK +
          otherData.image_url +
          storeMapping.RestaurantManagement[0].restaurant_image,
      );

      let table_code = storeMapping.DiningAreaTableSetupSetting[0].table_code;
      let table_id = storeMapping.DiningAreaTableSetupSetting[0].primary_id;
      let dining_area_id =
        storeMapping.DiningAreaTableSetupSetting[0].dining_area_id;
      setactivetable(table_code);
      setTableCodeID(table_id);
      setAreaID(dining_area_id);
      settable_area_name(
        storeMapping.DiningAreaTableSetupSetting[0].table_list_data[0]
          .dining_area_name,
      );
      setActiveCatagory(storeMapping.CategoryManagement[0].primary_id);

      await Promise.all(
        Object.entries(storeMapping).map(([storeName, storeData]) =>
          storeData
            ? StoreDataintoIndexDB(
                transaction_call,
                storeName,
                storeData.data || storeData,
                { flag: storeData.clearFlag || "0", clear_or_not: "clear" },
              )
            : Promise.resolve(),
        ),
      );

      const posTempCart = await RetrieveDataintoIndexDBOrder(
        result,
        CustomerOrderDetail,
        { table_no: table_code, order_id: OrderID, details_wala: "2" },
      );
      if (posTempCart?.length > 0) {
        setOrderID(posTempCart[0].order_id);
      }
      setStoreData(posTempCart);
      change_calculation(4, posTempCart, result, null, 1, null);
    } catch (error) {
      handleError(error);
      console.error("Error fetching data:", error);
    }
  };

  const handleAddToCart = async (full_data, plus_min, from_where) => {
    if (
      parseInt(from_where) === 0 &&
      (parseInt(full_data.add_addon_status) === 1 ||
        parseInt(full_data.add_variation_with_addon_status) === 1 ||
        parseInt(full_data.add_variation_status) === 1)
    ) {
      let addonIdsArray = full_data.addon_data_ids
        .split(",")
        .map((id) => id.trim());
      setSelectedItem(full_data);
      let data_come_item_addon = foodItemsAddonitem.filter((item) =>
        addonIdsArray.includes(String(item.addon_cat_id)),
      );
      let data_come_item_addon_main = foodItemsAddon.filter((item) =>
        addonIdsArray.includes(String(item.primary_id)),
      );
      let data_come_variation = foodItemsVari.filter(
        (item) => item.menu_id === full_data.primary_id,
      );
      let data_come_variation_menu = foodItemsAddonVari.filter(
        (item) => item.menu_id === full_data.primary_id,
      );
      let data_come_variation_combo = foodItemsAddonitemcombo.filter(
        (item) => item.combo_id === full_data.primary_id,
      );
      if (data_come_item_addon) {
        setselectedfoodItemsVari(data_come_variation);
        setselectedfoodItemsAddonVari(data_come_variation_menu);
        setselectedfoodItemsAddon(data_come_item_addon_main);
        setselectedfoodItemsAddonitem(data_come_item_addon);
        setselectedfoodItemsAddonitemcombo(data_come_variation_combo);
      }
      setShowAddOnModal(true);
    } else if (
      from_where === "0" &&
      parseInt(full_data.add_combo_status) === 1
    ) {
      let data_come_variation_combo = foodItemsAddonitemcombo.filter(
        (item) => item.combo_id === full_data.primary_id,
      );
      setselectedfoodItemsAddonitemcombo(data_come_variation_combo);
      const transaction_call = db.transaction(array_data_base, "readwrite");
      let order_id_get = await StoreDataItemintoIndexDB(
        transaction_call,
        CustomerOrderDetail,
        full_data,
        activeState,
        {
          area_id: AreaID,
          table_code_ids: TableCodeID,
          table_area_name,
          selectedAddons: null,
          selectedVariation: null,
          selectedcombo: data_come_variation_combo,
          total_amount: 0,
          plus_min,
          table_no: activetable,
          order_id: OrderID,
          type: activeState,
        },
      );
      if (parseInt(order_id_get) > 0) {
        setOrderID(order_id_get);
      } else {
        order_id_get = OrderID;
      }
      const save_pos_temp_cart = await RetrieveDataintoIndexDBOrder(
        db,
        CustomerOrderDetail,
        { table_no: activetable, order_id: order_id_get, details_wala: "2" },
      );
      setStoreData(save_pos_temp_cart);
      change_calculation(4, save_pos_temp_cart, null, order_id_get, 2, null);
    } else {
      const transaction_call = db.transaction(array_data_base, "readwrite");
      let selectedAddons = null,
        selectedVariation = null,
        selectedcombo = null;
      if (full_data.selectedAddons) {
        selectedAddons = [full_data.selectedAddons].map((item) =>
          typeof item === "string"
            ? JSON.parse(item.replace(/'/g, '"').replace(/\bNone\b/g, "null"))
            : item,
        )[0];
      }
      if (full_data.selectedAddons) {
        selectedVariation = [full_data.selectedVariation].map((item) =>
          typeof item === "string"
            ? JSON.parse(item.replace(/'/g, '"').replace(/\bNone\b/g, "null"))
            : item,
        )[0];
      }
      if (full_data.selectedcombo) {
        selectedcombo = [full_data.selectedcombo].map((item) =>
          typeof item === "string"
            ? JSON.parse(item.replace(/'/g, '"').replace(/\bNone\b/g, "null"))
            : item,
        )[0];
      }
      let order_id_get = await StoreDataItemintoIndexDB(
        transaction_call,
        CustomerOrderDetail,
        full_data,
        activeState,
        {
          area_id: AreaID,
          table_code_ids: TableCodeID,
          table_area_name,
          selectedAddons,
          selectedVariation,
          selectedcombo,
          total_amount: 0,
          plus_min,
          table_no: activetable,
          order_id: OrderID,
          type: activeState,
        },
      );
      if (parseInt(order_id_get) > 0) {
        setOrderID(order_id_get);
      } else {
        order_id_get = OrderID;
      }
      const save_pos_temp_cart = await RetrieveDataintoIndexDBOrder(
        db,
        CustomerOrderDetail,
        { table_no: activetable, order_id: order_id_get, details_wala: "2" },
      );
      setStoreData(save_pos_temp_cart);
      change_calculation(4, save_pos_temp_cart, null, order_id_get, 2, null);
    }
  };

  const handleAddToCartFromPopup = async (full_data) => {
    const transaction_call = db.transaction(array_data_base, "readwrite");
    let order_id_get = await StoreDataItemintoIndexDB(
      transaction_call,
      CustomerOrderDetail,
      full_data.item,
      activeState,
      {
        area_id: AreaID,
        table_code_ids: TableCodeID,
        table_area_name,
        selectedAddons: full_data.selectedAddons,
        selectedVariation: full_data.selectedVariation,
        selectedcombo: null,
        total_amount: full_data.total_amount,
        plus_min: "plus",
        table_no: activetable,
        order_id: OrderID,
        type: activeState,
      },
    );
    if (parseInt(order_id_get) > 0) {
      setOrderID(order_id_get);
    } else {
      order_id_get = OrderID;
    }
    const save_pos_temp_cart = await RetrieveDataintoIndexDBOrder(
      db,
      CustomerOrderDetail,
      { table_no: activetable, order_id: order_id_get, details_wala: "2" },
    );
    setStoreData(save_pos_temp_cart);
    change_calculation(4, save_pos_temp_cart, null, order_id_get, 2, null);
    setShowAddOnModal(false);
  };

  const change_calculation = async (
    click_type,
    e,
    db_data = null,
    order_id = null,
    call_time = 2,
    guestData,
  ) => {
    if (click_type !== 4 && click_type !== 5) {
      if (e.target.value !== "") {
        e.target.value = e.target.value.replace(/[^0-9.]/g, "");
        e.target.value = e.target.value.replace(
          /(\d{0,9}(?:\.\d{0,2})?).*$/g,
          "$1",
        );
      } else {
        e.target.value = 0;
      }
    }
    let StoreDatat_get = StoreData;
    let Delivery_Charge = 0,
      tip_amount = 0,
      tax_amount = TaxPer;
    let Product_Price = 0,
      Discount_amount = 0,
      Taxes_amount = 0,
      Packing_Charge = 0,
      Final_Price = 0,
      roundoff_amount = 0;
    if (click_type === 1) Delivery_Charge = e.target.value;
    else if (click_type === 2) tip_amount = e.target.value;
    else if (click_type === 4) StoreDatat_get = e;
    let db_data_final = db;
    if (db_data != null) db_data_final = db_data;
    StoreDatat_get.forEach((dataItem) => {
      Product_Price += Number(dataItem.total_price_show);
    });
    setProductPrice(Product_Price);
    if (Number(tax_amount) > 0 && Number(Product_Price) > 0)
      Taxes_amount = (Number(tax_amount) / 100) * Number(Product_Price);
    setTaxPrice(Taxes_amount);
    let discount_id = 0,
      discount_custom_type = "",
      discount_code_name = "",
      discount_type = "",
      discount_reason = "",
      discount_amount_value = 0,
      discount_amount = 0;
    let product_order = Product_Price;
    if (discount_type === "Percentage") {
      discount_amount =
        discount_amount_value > 99
          ? 0
          : (product_order * discount_amount_value) / 100;
    } else {
      discount_amount =
        discount_amount_value > product_order ? 0 : discount_amount_value;
    }
    Discount_amount = discount_amount;
    if (order_id === null) order_id = OrderID;
    if (Product_Price < Discount_amount) {
      Discount_amount = 0;
      discount_id = 0;
      discount_custom_type = "";
      discount_code_name = "";
      discount_type = "";
      discount_reason = "";
      discount_amount_value = 0;
    }
    Final_Price =
      Number(Product_Price) -
      Number(Discount_amount) +
      Number(Taxes_amount) +
      Number(Packing_Charge) +
      Number(Delivery_Charge) +
      Number(tip_amount);
    roundoff_amount = Final_Price - Math.round(Final_Price);
    Final_Price = Final_Price - roundoff_amount;
    if (call_time === 2) {
      await StoreDataCustomerOrderintoIndexDB(
        db,
        {
          product_amount: Product_Price,
          tax_per: tax_amount,
          tax_amount: Taxes_amount,
          packing_amount: Packing_Charge,
          discount_amount: Discount_amount,
          delivery_amount: Delivery_Charge,
          tip_amount,
          roundoff_amount,
          final_amount: Final_Price,
        },
        order_id,
      );
    }
    const save_pos_temp_cart2 = await RetrieveDataintoIndexDBOrder(
      db_data_final,
      CustomerOrder,
      { table_no: activetable, order_id, details_wala: "2" },
    );
    setStoreDataDetails(save_pos_temp_cart2);
    settotalPrice(Final_Price);
  };

  const SelectCategory = (state) => {
    if (state !== 0) {
      setActiveCatagory(state.primary_id);
    } else {
      setActiveCatagory(0);
    }
  };

  const handleAddSpecialNotes = (e) => {
    const value = e.target.value;
    if (value !== "") {
      setNotes(value);
      StoreDataCustomerOrderintoIndexDB(
        db,
        { special_instruction: value },
        OrderID,
      );
    }
  };

  // ─────────────────────────────────────────────────────────────────────────
  // confirmOrder — auto gateway detection
  // Pehle: sirf pay_url pe redirect karta tha (PhonePe only)
  // Ab:    gateway_type check karo → PhonePe redirect ya Razorpay SDK popup
  // ─────────────────────────────────────────────────────────────────────────
  const confirmOrder = async () => {
    let vaild_data = true;
    if (vaild_data) {
      setshowLoaderAdmin(true);

      // ── IndexDB se order data lo ──────────────────────────────────────────
      const customer_order_data = await RetrieveDataintoIndexDBOrder(
        db,
        CustomerOrder,
        { table_no: activetable, order_id: OrderID, details_wala: "2" },
      );
      const customer_order_details = await RetrieveDataintoIndexDBOrder(
        db,
        CustomerOrderDetail,
        { table_no: activetable, order_id: OrderID, details_wala: "2" },
      );

      if (customer_order_details.length === 0) {
        handleError(
          "No Order Found. Please make sure you have placed an order.",
        );
        setshowLoaderAdmin(false);
        return;
      }

      // ── Backend ko bhejo ─────────────────────────────────────────────────
      const fd_from = new FormData();
      fd_from.append(
        "customer_order_data",
        JSON.stringify(customer_order_data),
      );
      fd_from.append(
        "customer_order_data_details",
        JSON.stringify(customer_order_details),
      );
      fd_from.append(
        "default_restaurant_id",
        RestaurantManagementData.primary_id,
      );
      fd_from.append("encrypted_restaurant_id", id);
      fd_from.append("encrypted_table_id", id2);

      try {
        const Response = await server_post_data(
          process_order,
          fd_from,
          RestaurantManagementData.database_name,
        );
        console.log("Response", Response);
        setshowLoaderAdmin(false);

        if (Response.data.error) {
          handleError(Response.data.message);
          return;
        }

        const { gateway_type, message } = Response.data;

        // Common data store
        setShowCheckout(false);
        storeData("last_order_id", message.order_id);
        storeData("encrypted_restaurant_id", id);
        storeData("encrypted_table_id", id2);
        storeData("last_database_name", RestaurantManagementData.database_name);

        // ══════════════════════════════════════════════════════════════════
        // PHONEPE — same as before, redirect to pay_url
        // ══════════════════════════════════════════════════════════════════
        if (gateway_type === "phonepe") {
          const pay_url = message?.pay_url;
          if (!pay_url) {
            handleError("PhonePe payment URL missing");
            return;
          }
          handleLinkClick(pay_url); // window.location.href jaisa kaam karta hai
        }

        // ══════════════════════════════════════════════════════════════════
        // RAZORPAY — SDK load karo, checkout popup kholo
        // ══════════════════════════════════════════════════════════════════
        else if (gateway_type === "razorpay") {
          const sdkLoaded = await loadRazorpaySDK();
          if (!sdkLoaded) {
            handleError("Razorpay SDK load nahi hua. Please try again.");
            return;
          }

          const {
            razorpay_order_id,
            merchant_order_id,
            amount_paise,
            currency,
            key_id,
            prefill,
            callback_url,
          } = message;

          const options = {
            key: key_id,
            amount: amount_paise,
            currency: currency || "INR",
            order_id: razorpay_order_id,
            name: RestaurantName,
            description: `Table ${activetable} Order`,

            prefill: {
              name: prefill?.name || "",
              email: prefill?.email || "",
              contact: prefill?.contact || "",
            },

            theme: {
              color: RestaurantManagementData?.theme_color || "#33AFC6",
            },

            // ── Payment success handler ─────────────────────────────────
            handler: async function (razorpayResponse) {
              try {
                // Backend pe signature verify karo
                const verifyForm = new FormData();
                verifyForm.append("merchant_order_id", merchant_order_id);
                verifyForm.append(
                  "razorpay_order_id",
                  razorpayResponse.razorpay_order_id,
                );
                verifyForm.append(
                  "razorpay_payment_id",
                  razorpayResponse.razorpay_payment_id,
                );
                verifyForm.append(
                  "razorpay_signature",
                  razorpayResponse.razorpay_signature,
                );

                const Response = await server_post_data(
                  callback_url,
                  verifyForm,
                  RestaurantManagementData.database_name,
                );

                if (Response.data.error) {
                  handleError(Response.data.message);
                  return;
                } else {
                  const pay_url = Response.data.message.pay_url;
                  if (!pay_url) {
                    handleError("Razorpay payment URL missing");
                    return;
                  }
                  handleLinkClick(pay_url); // window.location.href jaisa kaam karta hai
                }
              } catch (err) {
                console.error("Razorpay verify error:", err);
                handleError(
                  "Payment verification error. Please contact support.",
                );
              }
            },

            // ── User ne modal band kiya ─────────────────────────────────
            modal: {
              ondismiss: function () {
                handleError("Payment cancelled. Please try again.");
              },
            },
          };

          const rzp = new window.Razorpay(options);

          // ── Payment failed ──────────────────────────────────────────────
          rzp.on("payment.failed", function (resp) {
            handleError(`Payment failed: ${resp.error.description}`);
          });

          rzp.open();
        }

        // ── Unknown gateway ─────────────────────────────────────────────────
        else {
          handleError(`Unknown payment gateway: ${gateway_type}`);
        }
      } catch (error) {
        console.log(error);
        setshowLoaderAdmin(false);
        handleError("Something went wrong. Please try again.");
      }
    }
  };

  const handleCheckout = () => setShowCheckout(true);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  const [sHowItesm, setSHowItesm] = useState(false);
  const toggleItyem = () => {
    if (!sHowItesm) {
      setSHowItesm(true);
      setShowCheckout(false);
    } else {
      setSHowItesm(false);
    }
  };

  const [openCategory, setOpenCategory] = useState(null);
  const toggleCategory = (categoryName) =>
    setOpenCategory(openCategory === categoryName ? null : categoryName);

  const [isOpen, setIsOpen] = useState(false);
  const toggleCategoryBox = () => setIsOpen(!isOpen);

  const VegIcon = () => (
    <div
      style={{
        width: "20px",
        height: "20px",
        border: "2px solid #10b981",
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      <div
        style={{
          width: "8px",
          height: "8px",
          backgroundColor: "#10b981",
          borderRadius: "50%",
        }}
      ></div>
    </div>
  );

  const NonVegIcon = () => (
    <div
      style={{
        width: "20px",
        height: "20px",
        border: "2px solid #ef4444",
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      <div
        style={{
          width: "8px",
          height: "8px",
          backgroundColor: "#ef4444",
          borderRadius: "50%",
        }}
      ></div>
    </div>
  );

  const MenuItem = ({ item, index }) => {
    const [expanded, setExpanded] = useState(false);
    const [quantity, setQuantity] = useState(0);
    const maxLength = 80;
    const isLong =
      item.item_description &&
      item.item_description !== "nan" &&
      item.item_description.length > maxLength;
    const shortText = item.item_description?.substring(0, maxLength);
    const isInCart = quantity > 0;
    const toggleReadMore = () => setExpanded(!expanded);
    const handleClick = (action) => {
      if (action === "plus") setQuantity(quantity + 1);
      else if (action === "min" && quantity > 0) setQuantity(quantity - 1);
    };
    return (
      <div className="col-12 mb-2">
        <div
          style={{
            position: "relative",
            backgroundColor: "#fff",
            borderRadius: "8px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            border: "1px solid #e5e7eb",
            overflow: "hidden",
          }}
        >
          <div style={{ display: "flex", gap: "12px", padding: "12px" }}>
            <div style={{ flex: 1 }}>
              <div
                style={{
                  paddingTop: "0.5rem",
                  display: "flex",
                  gap: "8px",
                  alignItems: "start",
                  marginBottom: "8px",
                }}
              >
                {item.item_class?.toLowerCase() === "veg" ? (
                  <VegIcon />
                ) : (
                  <NonVegIcon />
                )}
                <h5
                  style={{
                    margin: 0,
                    fontWeight: "600",
                    fontSize: "16px",
                    color: "#1f2937",
                  }}
                >
                  {item.item_name}
                </h5>
              </div>
              {item.item_description && item.item_description !== "nan" && (
                <p
                  style={{
                    color: "#6b7280",
                    fontSize: "14px",
                    margin: "0 0 8px 0",
                    lineHeight: "1.5",
                  }}
                >
                  {expanded || !isLong
                    ? item.item_description
                    : `${shortText}...`}
                  {isLong && (
                    <span
                      onClick={toggleReadMore}
                      style={{
                        color: "#f59c29",
                        cursor: "pointer",
                        marginLeft: "5px",
                        fontWeight: "500",
                      }}
                    >
                      {expanded ? "Read Less" : "Read More"}
                    </span>
                  )}
                </p>
              )}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "12px",
                }}
              >
                <p
                  style={{
                    fontWeight: "bold",
                    margin: 0,
                    fontSize: "16px",
                    color: "#1f2937",
                  }}
                >
                  ₹{parseFloat(item.item_original_price).toFixed(2)}
                </p>
                <div>
                  {isInCart ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        border: "2px solid #f59c29",
                        borderRadius: "8px",
                        overflow: "hidden",
                      }}
                    >
                      <button
                        style={{
                          padding: "6px 12px",
                          backgroundColor: "#fff",
                          color: "#f59c29",
                          border: "none",
                          cursor: "pointer",
                        }}
                        onClick={() => handleClick("min")}
                      >
                        <Minus size={16} />
                      </button>
                      <span
                        style={{
                          padding: "0 8px",
                          fontWeight: "600",
                          color: "#f59c29",
                        }}
                      >
                        {quantity}
                      </span>
                      <button
                        style={{
                          padding: "6px 12px",
                          backgroundColor: "#fff",
                          color: "#f59c29",
                          border: "none",
                          cursor: "pointer",
                        }}
                        onClick={() => handleClick("plus")}
                      >
                        <Plus size={16} />
                      </button>
                    </div>
                  ) : (
                    <button
                      style={{
                        padding: "6px 24px",
                        backgroundColor: "#fff",
                        border: "2px solid #f59c29",
                        color: "#f59c29",
                        fontWeight: "600",
                        borderRadius: "8px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleClick("plus")}
                    >
                      Add
                    </button>
                  )}
                </div>
              </div>
            </div>
            {item.item_image && (
              <div style={{ width: "112px", height: "112px", flexShrink: 0 }}>
                <img
                  src={item.item_image}
                  alt={item.item_name}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {showSplash ? (
        <div className="Uprestro-app">
          <div className="background-pattern"></div>
          <div className="content-container">
            <div className="logo-container">
              <div className="logoCOntainer">
                <img
                  src={RestaurantLogo}
                  alt={RestaurantName}
                  className="logo-box"
                />
              </div>
              <h1 className="brand-name">{RestaurantName}</h1>
              <h2 className="location">{RestaurantNameTagLine}</h2>
            </div>
            <div className="welcome-section">
              <h3 className="welcome-text">Welcome To {RestaurantName}</h3>
              <button
                className="order-button"
                onClick={() => setshowSplash(false)}
              >
                Order Now
              </button>
            </div>
            <footer className="Uprestro-footer">
              <div className="footer-links">
                <a style={{ whiteSpace: "nowrap" }} href="/privacy-policy">
                  Privacy Policy
                </a>{" "}
                &nbsp;|&nbsp;
                <a style={{ whiteSpace: "nowrap" }} href="/refund-policy">
                  Refund Policy
                </a>{" "}
                &nbsp;|&nbsp;
                <a
                  style={{ whiteSpace: "nowrap" }}
                  href="/terms-and-conditions"
                >
                  Terms & Conditions
                </a>{" "}
                &nbsp;|&nbsp;
                <a style={{ whiteSpace: "nowrap" }} href="/contact-us">
                  Contact Us
                </a>
              </div>
            </footer>
          </div>
        </div>
      ) : (
        <div className="pos-dashboard">
          <header className="app-header">
            <div className="container-fluid">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <h5 className="mb-0" style={{ fontWeight: 700 }}>
                    {RestaurantName}
                  </h5>
                </div>
                <button
                  className="cart-btn"
                  onClick={() => {
                    setShowCheckout(true);
                    setSHowItesm(false);
                  }}
                >
                  <ShoppingCart color="#2f2f2f" size={24} />
                  {StoreData.length > 0 && (
                    <span className="cart-badge">{StoreData.length}</span>
                  )}
                </button>
              </div>
            </div>
          </header>

          <div
            className={`sidebar-backdrop ${sidebarOpen ? "show" : ""}`}
            onClick={toggleSidebar}
          ></div>
          <div className={`sidebar ${sidebarOpen ? "open" : ""}`}>
            <div className="sidebar-header">
              <h5 className="mb-0">Menu</h5>
              <button className="close-btn" onClick={toggleSidebar}>
                <X size={24} />
              </button>
            </div>
            <div className="p-3">
              {foodCategories.map((category, index) => (
                <div
                  key={index}
                  className={`category-item ${activeCatagory === category.primary_id ? "active" : ""}`}
                  onClick={() => SelectCategory(category)}
                >
                  {category.item_category}
                </div>
              ))}
            </div>
          </div>

          <div
            className="container-fluid"
            style={{ height: "calc(100vh - 141px)" }}
          >
            <div className="row m-auto">
              <div
                className={`${showCheckout || sHowItesm ? "d-none" : ""} col-12`}
              >
                <div
                  className={`row ${StoreData.length > 0 ? "heigh_clss" : "heigh_clss_show_check_out"}`}
                >
                  {foodCategories.map((category, index) => (
                    <div
                      key={index}
                      className="category-section"
                      name={`cata-${category.primary_id}`}
                      id={`cata-${category.primary_id}`}
                    >
                      <button
                        onClick={() => {
                          toggleCategory(category.item_category);
                          SelectCategory(category);
                        }}
                        className={`category-button category-item ${activeCatagory === category.primary_id ? "active" : "active"}`}
                      >
                        {category.item_category}
                      </button>
                      {foodItems
                        .filter((item) => item.cate_id === category.primary_id)
                        .map((item, index) => {
                          const matchedItem = StoreData.find(
                            (cartItem) => cartItem.item_id === item.primary_id,
                          );
                          const isInCart = Boolean(matchedItem);
                          const quantity = matchedItem?.item_qty || 0;
                          const handleClick = (action) =>
                            handleAddToCart(
                              isInCart ? matchedItem : item,
                              action,
                              isInCart ? "1" : "0",
                            );
                          const toggleReadMore = () =>
                            setExpanded((prev) => !prev);
                          const isLong = item.item_description.length > 50;
                          const shortText = item.item_description.slice(0, 60);
                          return (
                            <div key={index} className="col-12 mb-2">
                              <div className="menu-item position-relative">
                                <div style={{ display: "flex", gap: "12px" }}>
                                  <div style={{ flex: 1 }}>
                                    <div
                                      className="px-2"
                                      style={{
                                        paddingTop: "0.5rem",
                                        display: "flex",
                                        gap: "6px",
                                        alignItems: "start",
                                      }}
                                    >
                                      {item.item_class.toLowerCase() ===
                                      "veg" ? (
                                        <img
                                          className="vegIcon"
                                          src={Veg}
                                          alt="Veg Food"
                                        />
                                      ) : (
                                        <img
                                          className="vegIcon"
                                          src={nonveg}
                                          alt="Non Veg Food"
                                        />
                                      )}
                                      <h5 className="m-0 menuItemNmae">
                                        {item.item_name}
                                      </h5>
                                    </div>
                                    {item.item_description != "nan" && (
                                      <p
                                        className="text-muted small px-2"
                                        style={{ marginBottom: "4px" }}
                                      >
                                        {expanded || !isLong
                                          ? item.item_description
                                          : `${shortText}...`}
                                        {isLong && (
                                          <span
                                            onClick={toggleReadMore}
                                            style={{
                                              color: "#f59c29",
                                              cursor: "pointer",
                                              marginLeft: "5px",
                                            }}
                                          >
                                            {expanded
                                              ? "Read Less"
                                              : "Read More"}
                                          </span>
                                        )}
                                      </p>
                                    )}
                                    <p
                                      className="fw-bold m-2"
                                      style={{ marginBottom: "8px" }}
                                    >
                                      ₹
                                      {parseFloat(
                                        item.item_original_price,
                                      ).toFixed(2)}
                                    </p>
                                  </div>
                                  {item.item_image_url &&
                                    item.item_image_url != "" &&
                                    item.item_image_url != null &&
                                    item.item_image_url.length > 5 && (
                                      <div
                                        style={{
                                          position: "relative",
                                          width: "100px",
                                          height: "100px",
                                          flexShrink: 0,
                                          marginRight: "8px",
                                          marginTop: "8px",
                                        }}
                                      >
                                        <img
                                          src={item.item_image_url}
                                          alt={item.item_name}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            borderRadius: "8px",
                                          }}
                                          onError={(e) => {
                                            e.target.style.display = "none";
                                          }}
                                        />
                                        <div
                                          style={{
                                            position: "absolute",
                                            bottom: "-6px",
                                            left: "50%",
                                            transform: "translateX(-50%)",
                                          }}
                                        >
                                          {isInCart ? (
                                            <div
                                              className="quantity-control"
                                              style={{ padding: "1px" }}
                                            >
                                              <button
                                                className="qty-btn minus-btn"
                                                style={{
                                                  width: "26px",
                                                  height: "26px",
                                                }}
                                                onClick={() =>
                                                  handleClick("min")
                                                }
                                              >
                                                <Minus size={14} />
                                              </button>
                                              <span
                                                className="qty-text"
                                                style={{
                                                  fontSize: "14px",
                                                  margin: "0 6px",
                                                }}
                                              >
                                                {quantity}
                                              </span>
                                              <button
                                                className="qty-btn plus-btn"
                                                style={{
                                                  width: "26px",
                                                  height: "26px",
                                                }}
                                                onClick={() =>
                                                  handleClick("plus")
                                                }
                                              >
                                                <Plus size={14} />
                                              </button>
                                            </div>
                                          ) : (
                                            <button
                                              className="add-btn"
                                              style={{
                                                padding: "4px 16px",
                                                fontSize: "12px",
                                                fontWeight: "600",
                                              }}
                                              onClick={() =>
                                                handleClick("plus")
                                              }
                                            >
                                              Add
                                            </button>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                </div>
                                {(!item.item_image_url ||
                                  item.item_image_url == "" ||
                                  item.item_image_url == null ||
                                  item.item_image_url.length <= 5) && (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      padding: "0 8px 8px 0",
                                    }}
                                  >
                                    {isInCart ? (
                                      <div className="quantity-control">
                                        <button
                                          className="qty-btn minus-btn"
                                          onClick={() => handleClick("min")}
                                        >
                                          <Minus size={16} />
                                        </button>
                                        <span className="qty-text">
                                          {quantity}
                                        </span>
                                        <button
                                          className="qty-btn plus-btn"
                                          onClick={() => handleClick("plus")}
                                        >
                                          <Plus size={16} />
                                        </button>
                                      </div>
                                    ) : (
                                      <button
                                        className="add-btn"
                                        onClick={() => handleClick("plus")}
                                      >
                                        Add
                                      </button>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  ))}
                </div>
              </div>

              {showAddonModal && (
                <AddOnModal
                  isOpen={showAddonModal}
                  onClose={() => setShowAddOnModal(false)}
                  onCloseSave={(ssss) => handleAddToCartFromPopup(ssss)}
                  item={selectedItem}
                  selectedfoodItemsVari={selectedfoodItemsVari}
                  selectedfoodItemsAddonVari={selectedfoodItemsAddonVari}
                  selectedfoodItemsAddonitemcombo={
                    selectedfoodItemsAddonitemcombo
                  }
                  selectedfoodItemsAddon={selectedfoodItemsAddon}
                  selectedfoodItemsAddonitem={selectedfoodItemsAddonitem}
                />
              )}

              {showCheckout && (
                <div className="col-12">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="mb-0">Checkout</h4>
                    </div>
                    <div className="card-body">
                      <div className="mb-4">
                        <h5 className="mb-3">Order Items</h5>
                        {StoreData.map((item, index) => (
                          <div
                            key={index}
                            className="d-flex justify-content-between mb-2"
                          >
                            <div>
                              <span style={{ color: "#5b5b5b" }}>
                                {item.item_name}
                              </span>{" "}
                              <span
                                style={{ fontSize: "13px", fontWeight: "600" }}
                              >
                                x {item.item_qty}
                              </span>
                            </div>
                            <div>
                              ₹{parseFloat(item.total_price_show).toFixed(2)}
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="divider"></div>
                      <div className="mb-4">
                        <h5 className="mb-2">
                          Table No:{" "}
                          <span style={{ color: "red" }}>{activetable}</span>
                        </h5>
                        <div className="radio-group">
                          <label className="radio-item"></label>
                        </div>
                      </div>
                      <div className="mb-4">
                        <h5 className="mb-2">More Instructions</h5>
                        <textarea
                          className="form-control"
                          rows="3"
                          value={notes}
                          onChange={(e) => handleAddSpecialNotes(e)}
                          placeholder="Add special instructions here..."
                        ></textarea>
                      </div>
                      <div className="divider"></div>
                      <div className="mb-5">
                        <div className="d-flex justify-content-between">
                          <div>Item total</div>
                          <div>₹{parseFloat(ProductPrice).toFixed(2)}</div>
                        </div>
                        <div className="d-flex justify-content-between">
                          <div>Taxes</div>
                          <div>₹{parseFloat(TaxPrice).toFixed(2)}</div>
                        </div>
                        <div
                          className="d-flex justify-content-between"
                          style={{ fontWeight: "900" }}
                        >
                          <h5 className="mb-0">Grand total</h5>
                          <h5 className="mb-0">
                            ₹{parseFloat(totalPrice).toFixed(2)}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {sHowItesm && (
                <>
                  {StoreData.length > 0 && (
                    <div className="col-12">
                      <div className="card">
                        <div className="card-header">Items</div>
                        <div className="card-body">
                          {StoreData.map((item, index) => (
                            <div
                              key={index}
                              className="d-flex align-items-center mb-2"
                            >
                              <div className="me-auto">
                                <div>{item.item_name}</div>
                                <div className="text-muted">
                                  ₹
                                  {parseFloat(item.total_price_show).toFixed(2)}
                                </div>
                              </div>
                              <div className="quantity-control">
                                <button
                                  className="qty-btn minus-btn"
                                  onClick={() =>
                                    handleAddToCart(item, "min", "1")
                                  }
                                >
                                  <Minus size={16} />
                                </button>
                                <span className="qty-text">
                                  {item.item_qty}
                                </span>
                                <button
                                  className="qty-btn plus-btn"
                                  onClick={() =>
                                    handleAddToCart(item, "plus", "1")
                                  }
                                >
                                  <Plus size={16} />
                                </button>
                                <button
                                  className="qty-btn"
                                  onClick={() =>
                                    handleAddToCart(item, "remove", "1")
                                  }
                                >
                                  <Trash2 size={16} />
                                </button>
                              </div>
                            </div>
                          ))}
                          <div className="divider"></div>
                          <div className="d-flex justify-content-between">
                            <div>Total:</div>
                            <div>₹{parseFloat(totalPrice).toFixed(2)}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>

          {storeData.length > 0 && !showCheckout && (
            <div className="bottom-bar">
              <div className="container">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <div className="h5 mb-0">
                      ₹{parseFloat(totalPrice).toFixed(2)}
                    </div>
                  </div>
                  <button className="checkout-btn" onClick={handleCheckout}>
                    Check Out
                  </button>
                </div>
              </div>
              <div className="floating-container">
                <button className="floating-button" onClick={toggleCategoryBox}>
                  Menu
                </button>
              </div>
            </div>
          )}

          {isOpen && (
            <div className="category-box card">
              <ul className="list-group list-group-flush">
                {foodCategories.map((category, index) => (
                  <a
                    href={`#cata-${category.primary_id}`}
                    onClick={(e) => {
                      toggleCategoryBox();
                      toggleCategory(category.item_category);
                      SelectCategory(category);
                      window.scrollTo({ top: 16, behavior: "smooth" });
                    }}
                    style={{
                      cursor: "pointer",
                      display: "block",
                      width: "100%",
                      textDecoration: "none",
                      color: "#2f2f2f",
                    }}
                  >
                    <li key={index} className="list-group-item">
                      {category.item_category}
                    </li>
                  </a>
                ))}
              </ul>
            </div>
          )}

          {showCheckout && !sHowItesm && (
            <div className="bottom-bar">
              <div className="container">
                <div className="d-flex justify-content-between">
                  <button
                    className="btn"
                    style={{ fontWeight: "600" }}
                    onClick={() => setShowCheckout(false)}
                  >
                    ← Back to Menu
                  </button>
                  {/* ── Confirm Order button — loader bhi dikhata hai ── */}
                  <button
                    className="confirm-btn"
                    onClick={confirmOrder}
                    disabled={showLoaderAdmin}
                  >
                    {showLoaderAdmin ? "Processing..." : "Confirm Order"}
                  </button>
                </div>
              </div>
            </div>
          )}

          {sHowItesm && !showCheckout && (
            <div className="bottom-bar">
              <div className="container">
                <div className="d-flex justify-content-between">
                  <button
                    className="btn"
                    style={{ fontWeight: "600" }}
                    onClick={() => {
                      setShowCheckout(false);
                      setSHowItesm(false);
                    }}
                  >
                    ← Back to Menu
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}
